/* eslint-disable react/jsx-filename-extension */
import React from 'react';

export const technicalQuestions = [
  {
    id: 1,
    question: 'What equipment does Parity control in my building?',
    answer: (
      <article>
        Each building is unique. Parity controls the equipment where there are opportunities to improve operations and
        realize energy savings. In general, Parity controls any or all of the following:
        <p />
        <ul className="help-answer-list">
          <li>
            <div className="help-answer-list-bullet" />
            Heating Equipment (Boilers, Domestic Hot Water Pumps, Glycol Pumps)
          </li>
          <li>
            <div className="help-answer-list-bullet" />
            Cooling Equipment (Condenser Pumps, Chillers, Cooling Tower Fans)
          </li>
          <li>
            <div className="help-answer-list-bullet" />
            Ventilation (Make-up Air Units)
          </li>
          <li>
            <div className="help-answer-list-bullet" />
            Others (Cold Water Domestic Boosters Pumps, Heating/Cooling Hydronic Pumps, Exhaust Fans)
          </li>
        </ul>
        *Parity does not service any equipment.
      </article>
    ),
  },
  {
    id: 2,
    question: 'What equipment does Parity not control in my building?',
    answer: (
      <article>
        Each building is unique. Parity controls the equipment where there are opportunities to improve operations and
        realize energy savings. In general, Parity does
        <b>
          <u> not control</u>
        </b>
        &nbsp;or service any of the following:
        <p />
        <ul className="help-answer-list">
          <li>
            <div className="help-answer-list-bullet" />
            Lighting (Common area or suite area)
          </li>
          <li>
            <div className="help-answer-list-bullet" />
            Equipment with Small Motors (Auxiliary fans etc)
          </li>
          <li>
            <div className="help-answer-list-bullet" />
            Fire Pumps
          </li>
          <li>
            <div className="help-answer-list-bullet" />
            Generators
          </li>
          <li>
            <div className="help-answer-list-bullet" />
            Elevators
          </li>
          <li>
            <div className="help-answer-list-bullet" />
            Plug Loads
          </li>
        </ul>
        <li>Thermostatic mixing valves or anything that requires manual intervention.</li>
      </article>
    ),
  },
  {
    id: 3,
    question: 'How does Parity generate savings in my building?',
    answer: (
      <article>
        Parity controls setpoints on your building’s HVAC equipment and uses smart algorithms to optimize the output of
        the equipment. Our intent is to satisfy the building’s load requirements and occupant’s thermal comfort
        conditions with the least amount of energy output.
      </article>
    ),
  },
  {
    id: 4,
    question: 'How does Parity’s solution differ from a standard Building Automation System (BAS) system?',
    answer: (
      <article>
        <p>
          A standard Building Automation System (BAS) controls critical pieces of equipment, configured at the time of
          installation and then through various periods in its servicing contract. It is often serviced on site and does
          not consider energy consumption of the building holistically.
        </p>
        <p>
          Parity is an enhancement over the standard BAS. Parity’s real-time optimization software uses smart logic and
          deep learning algorithms to operate the equipment for best performance from an occupant comfort standpoint as
          well as building’s energy consumption. All data is stored in the cloud, and logic as well as control, can be
          deployed remotely. Parity guarantees energy cost savings through the on-going monitoring and smart operation
          of the building’s equipment.
        </p>
      </article>
    ),
  },
  {
    id: 5,
    question: 'How does Parity calculate savings in my building?',
    answer: (
      <article>
        <p>
          Parity uses the International Performance for Measurement and Verification Protocol (IPVMP) to calculate and
          verify your building’s energy savings.
        </p>
        <p>
          For Electricity Energy Savings (We use Option B): Retrofit Isolation methodology, in the majority of the
          cases. In this methodology, we calculate the difference between a weather-normalized baseline energy
          consumption (i.e. as the equipment was operating before implementing the Parity algorithms) and the
          weather-normalized actual energy consumption (i.e. as the equipment operates with Parity’s smart algorithms).
          In a small number of scenarios, where equipment-level data may have been in error, we calculate savings using
          Option C: Whole Facility methodology, described below.
        </p>
        <p>
          For Gas Energy Savings (We use Option C): Whole Facility methodology. In this methodology we perform a whole
          building weather-regression analysis using the gas utility bills. We calculate the difference between a
          baseline of your usage before the Parity algorithms were implemented and your actual consumption after the
          Parity algorithms were implemented.
        </p>
      </article>
    ),
  },
  {
    id: 6,
    question: 'What is weather adjustment?',
    answer: (
      <article>
        Weather adjustment is a statistical technique to normalize energy consumption against changing weather
        conditions. The energy consumption is normalized against heating degree days (HDD) in the winter and cooling
        degree days (CDD) in the summer. This means that the savings generated by Parity are not inflated due to a
        warmer winter or colder summer. The weather adjustment adheres to the guidelines of International Performance
        for Measurement and Verification Protocol (IPVMP).
      </article>
    ),
  },
  {
    id: 7,
    question: 'Do energy savings directly translate into savings I can see in my utility bills?',
    answer: (
      <article>
        Parity controls only a portion of your building’s equipment that contributes to your overall electricity and gas
        energy consumption. The cost savings are calculated based on estimated average utility rates which are set in
        your contract; these rates may differ from your actual utility rates in your bills during the contract term.
      </article>
    ),
  },
  {
    id: 8,
    question: 'Why does it take more than 30 days to receive my monthly report?',
    answer: (
      <article>
        Parity requires your utility bills to reconcile the accuracy of our energy savings calculations or to use them
        as the basis of the calculations. In Ontario, it often takes several months for us to receive you gas bills and
        this delays the finalization of the monthly reports.
      </article>
    ),
  },
  {
    id: 9,
    question: 'When do I contact Parity and when do I contact a mechanical contractor?',
    answer: (
      <article>
        Parity does not service any mechanical equipment however, during the hours of 6:00am to 12:00pm, Monday to
        Sunday, Parity’s support staff is available to help diagnose and resolve issues remotely.
      </article>
    ),
  },
];

export const agreementQuestions = [
  {
    id: 1,
    question: 'Why is there a software implementation period up to 60 days before we see savings?',
    answer: (
      <article>
        Once the hardware is installed and before Parity starts making adjustments, the system collects granular
        operating data to better understand your buildings unique patterns. Once ready, we begin optimizing the
        building. Your savings guarantee and billing start after the software implementation period is complete.
      </article>
    ),
  },
  {
    id: 2,
    question: 'When do payments start?',
    answer: (
      <article>
        Customers do not start any payments until Parity has been installed, completed the software implementation
        period and you are saving energy.
      </article>
    ),
  },
  {
    id: 3,
    question: 'When will we receive our first savings report?',
    answer: (
      <article>
        You will see your first savings report within 60 days following your first month of energy savings. The report
        will include an analysis of your energy consumption after reviewing the Parity data and your utility bills.
        After the first report, a new report will be provided monthly.
      </article>
    ),
  },
  {
    id: 4,
    question: 'What happens if we do not renew with Parity?',
    answer: (
      <article>
        All of the equipment installed is non-proprietary. While you would no longer benefit from Parity&apos;s
        monitoring of energy consumption, ongoing optimization and energy reporting you have improved your building with
        a building automation system that could be used by almost any mechanical contractor.
      </article>
    ),
  },
  {
    id: 5,
    question: 'When does the guarantee reconcile?',
    answer: (
      <article>
        The guarantee reconciles one year after your savings start date. At the end of every year an annual report is
        issued and if Parity is under the guaranteed savings then a payment will be issued to the corporation for the
        difference.
      </article>
    ),
  },
];
